module.exports = __webpack_public_path__ + "img/ma1.7a299599.jpg";